import { render, staticRenderFns } from "./PatternSetupEdit.vue?vue&type=template&id=50e7832e"
import script from "./PatternSetupEdit.vue?vue&type=script&lang=js"
export * from "./PatternSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports